export default __webpack_public_path__ + "static/media/oswald.19286529.ttf";